import * as React from "react";
import {Checkbox, Icon, Input, Modal, TextArea} from "semantic-ui-react";
import {formatDate} from "../../../components/Table/dataHandler/Utils";
import Button from "../../../components/Button";
import {ENewsPriority, NewsDto} from "../../../services/Client";

interface INotesAndNewsCreationDialogProps {
    editItem?: NewsDto;
    /** Callback when the user exits the dialog. */
    onExitDialog: (newsDto?: NewsDto) => any;
    t: reactI18Next.TranslationFunction;
}

interface INotesAndNewsCreationDialogState {
    title: string;
    content: string;
    priority: ENewsPriority;
    active: boolean;
}

class NotesAndNewsCreationDialog extends React.Component<INotesAndNewsCreationDialogProps, INotesAndNewsCreationDialogState> {
    TITLE_SIZE = 50;
    CONTENT_SIZE = 2048;

    constructor(props: INotesAndNewsCreationDialogProps) {
        super(props);

        this.state = {
            title: "",
            content: "",
            priority: ENewsPriority.INFO,
            active: true
        };
    }

    componentDidMount() {
        const {editItem} = this.props;
        if (editItem) {
            this.setState({
                title: editItem.title,
                content: editItem.content,
                active: editItem.active === undefined ? true : editItem.active,
                priority: editItem.priority === undefined ? ENewsPriority.INFO : editItem.priority
            });
        }
    }

    onClickCreate = (): void => {
        if (this.isFormValid()) {
            const newsDto: NewsDto = {
                title: this.state.title.trim(),
                content: this.state.content.trim(),
                active: this.state.active,
                priority: this.state.priority,
                objectId: 0, // dummy objectId for creation
                versionId: 0, // dummy versionId for creation
            };

            this.props.onExitDialog(newsDto);
        }
    }

    isFormValid = (): boolean => {
        const {active, priority} = this.state;
        const title = this.state.title.trim();
        const content = this.state.content.trim();
        const {editItem} = this.props;

        if (title.length > 0 && content.length > 0 && title.length <= this.TITLE_SIZE && content.length <= this.CONTENT_SIZE) {
            if (editItem) {
                return editItem.content !== content || editItem.title !== title || editItem.active !== active || editItem.priority !== priority;
            }
            return true;
        }
        return false;
    }

    render() {
        const {
            editItem,
            onExitDialog,
            t
        } = this.props;
        return (
            <Modal open={true}>
                <Modal.Header>
                    <div className='display--flex align-items--center justify-content--space-between'>
                        <span>
                            <Icon name='newspaper outline' size='large' />
                            {t("NOTES_AND_NEWS" + (editItem ? ":EDIT_NOTE_NEWS" : ":ADD_NOTE_NEWS"))}
                        </span>
                        {editItem && editItem.metadata &&
                            <div style={{fontSize: 14, color: 'grey', fontWeight: 'normal'}}>
                                {editItem.metadata.createdTimestamp &&
                                    <span className='margin-right--10px'>
                                        {t("NOTES_AND_NEWS:CREATED")}: {formatDate(editItem.metadata.createdTimestamp)}
                                    </span>
                                }
                                {editItem.metadata.changedTimestamp && editItem.metadata.changedTimestamp !== editItem.metadata.createdTimestamp &&
                                    <span>{t("NOTES_AND_NEWS:EDITED")}: {formatDate(editItem.metadata.changedTimestamp)}</span>
                                }
                            </div>
                        }
                    </div>
                </Modal.Header>
                <Modal.Content>
                    <div className='margin-bottom--10px'>
                        <label className='width--100Percent'>
                            <b>{t("NOTES_AND_NEWS:TITLE")}</b>
                        </label>
                        <Input
                            fluid={true}
                            value={this.state.title}
                            onChange={(e, v) => this.setState({title: v.value.substring(0, this.TITLE_SIZE)})}
                        />
                    </div>
                    <div>
                        <label className='width--100Percent'>
                            <b>{t("NOTES_AND_NEWS:CONTENT")}</b>
                        </label>
                        <TextArea
                            style={{width: "100%", height: 500, padding: 10}}
                            value={this.state.content}
                            onChange={(e) => this.setState({content: e.currentTarget.value.substring(0, this.CONTENT_SIZE)})}
                        />
                        <span>{this.CONTENT_SIZE - this.state.content.length} {t("NOTES_AND_NEWS:CHAR_LEFT")}</span>
                    </div>
                    <div className='display--flex align-items--center margin-top--10px'>
                        <label className='margin-right--10px'>
                            <b>{t("NOTES_AND_NEWS:HIGH_PRIORITY")}</b>
                        </label>
                        <Checkbox
                            toggle={true}
                            checked={this.state.priority === ENewsPriority.HIGH}
                            onChange={(e, v) =>
                                this.setState({
                                    priority: this.state.priority === ENewsPriority.HIGH ? ENewsPriority.INFO : ENewsPriority.HIGH
                                })}
                        />
                    </div>
                    <div className='display--flex align-items--center margin-top--10px'>
                        <label className='margin-right--10px'>
                            <b>{t("NOTES_AND_NEWS:ACTIVE")}</b>
                        </label>
                        <Checkbox
                            toggle={true}
                            checked={this.state.active}
                            onChange={(e, v) => this.setState({active: !this.state.active})}
                        />
                    </div>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        icon={"checkmark"}
                        onClick={this.onClickCreate}
                        disabled={!this.isFormValid()}
                    />
                    <Button
                        icon={"ban"}
                        onClick={() => onExitDialog()}
                    />
                </Modal.Actions>
            </Modal>
        );
    }
}

export default NotesAndNewsCreationDialog;



// WEBPACK FOOTER //
// ./src/views/AdminView/NotesAndNewsTab/NotesAndNewsCreationDialog.tsx